import React, { createContext, useContext, useEffect, useState } from "react";

const CompareContext = createContext(null);

export const CompareProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem("compare");
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem("compare", JSON.stringify(items));
    }, [items]);

    const add = (product) => {
        setItems((prev) => {
            if (prev.find((p) => p.id === product.id)) return prev;
            if (prev.length >= 3) return prev;
            // Only allow comparing same type
            if (prev.length > 0 && prev[0].type !== product.type) return prev;
            return [...prev, product];
        });
    };

    const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
    const clear = () => setItems([]);
    const has = (id) => items.some((p) => p.id === id);

    return (
        <CompareContext.Provider value={{ items, add, remove, clear, has }}>
            {children}
        </CompareContext.Provider>
    );
};

export const useCompare = () => useContext(CompareContext);
